import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Namespace, TFunction } from 'i18next';
import type { ZodTypeAny } from 'zod';

export function useZodSchema<TSchema extends ZodTypeAny>(
  factory: (t: TFunction) => TSchema,
  ...namespaces: [Namespace, ...Namespace[]]
): TSchema {
  const namespace = namespaces.length === 1 ? namespaces[0] : namespaces.flat();
  const { t } = useTranslation(namespace);

  return useMemo(() => factory(t), [t, factory]);
}
